/**
 * A prévia de etiqueta é o MESMO documento da impressão, com uma escala por
 * cima (F127, F129).
 *
 * A folha A4 tem 794 px de largura em CSS e a janela tem uns 600: sem escala a
 * prévia mostrava um pedaço da folha, cortado à direita, e parecia errada sem
 * estar. O `zoom` entra só no documento da prévia — o que vai para a
 * impressora continua em milímetro de verdade.
 */

/** 96 px por polegada é o que o CSS usa para `mm`. */
export const PX_PER_MM = 96 / 25.4

export const withZoom = (html: string, zoom: number): string =>
  html.replace(
    '</head>',
    `<style>html{zoom:${String(Math.round(zoom * 1000) / 1000)};background:#e5e7eb}body{background:#fff}</style></head>`
  )
